export default class FilterBar {
  constructor() {
    this.titleBar = document.querySelector('.title-bar');
    this.titleBarItemAll = document.querySelectorAll('.title-bar__item');
  }

  _removeClassActive() {
    [...this.titleBarItemAll].map(item => {
      item.classList.remove('title-bar__item--active');
    });
  }

  _activeAnchor(target) {
    this._removeClassActive();
    const currentElement = target.firstChild;
    target.classList.add('title-bar__item--active');

    const currentTitle = document.querySelector(currentElement.getAttribute('href')),
      titleOffset = currentTitle.getBoundingClientRect().top + window.pageYOffset - 45;

    const scrollTo = window.setInterval(() => {
      window.pageYOffset <= titleOffset && (window.innerHeight + window.pageYOffset) !== document.body.scrollHeight
        ? window.scrollTo(0, window.pageYOffset + 35)
        : currentTitle.getBoundingClientRect().top - 10 < 0
          ? window.scrollTo(0, window.pageYOffset - 35)
          : window.clearInterval(scrollTo);
    }, 1);

  }

  init() {

    if (this.titleBar) {
      this.titleBar.addEventListener('click', e => {
        e.preventDefault();
        e.target.closest('.title-bar__item')
          ? this._activeAnchor(e.target.closest('.title-bar__item'))
          : e.stopPropagation();
      });
    }
  }
}